export default require.context('../../img', true);
